import { useAccountMeta } from '@/contexts/account/account-context';

interface AccountScopeProps {
  children: React.ReactNode;
}

// Remounts the page on every workspace switch so no local state, form draft or
// seeded ref carries over to the next account. `inert` stops clicks landing on a
// page while the switch is in progress.
export function AccountScope({ children }: AccountScopeProps) {
  const { isTransitioning, workspaceGeneration } = useAccountMeta();

  return (
    <div key={workspaceGeneration} className="contents" inert={isTransitioning ? true : undefined}>
      {children}
    </div>
  );
}
